import {
   AfterViewInit,
   ChangeDetectorRef,
   Directive,
   ElementRef,
   EventEmitter,
   Input,
   OnDestroy,
   Output,
} from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { LcsSingleSelectDirective } from '../single-select.directive';
import { LcsStaticSingleSelectStatusService } from './static-single-select-status.service';

@Directive({
   // eslint-disable-next-line @angular-eslint/directive-selector
   selector: 'input[lcsStaticSelect]',
   standalone: false,
})
export class LcsStaticSingleSelectInputDirective<TItem> implements OnDestroy, AfterViewInit {
   @Input('lcsStaticSelectValue') get value(): TItem | null {
      return this._value;
   }

   set value(value: TItem | null) {
      this._value = value;

      if (this.trigger?.singleSelect?.keyManager) {
         this.setActiveItem(value);
      }
   }

   @Output() search = new EventEmitter<string | null | undefined>();

   // eslint-disable-next-line @angular-eslint/no-output-native
   @Output() reset = new EventEmitter<never>();

   private destroyed$ = new Subject<void>();

   private _value: TItem | null;

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<TItem>,
      private statusService: LcsStaticSingleSelectStatusService,
      private changeDetectorRef: ChangeDetectorRef
   ) {}

   ngAfterViewInit(): void {
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            (searchTerm?: string | null) => {
               return this.search.emit(this.formatSearchText(searchTerm));
            },
            () => {
               return this.reset.emit();
            },
            this.trigger.singleSelect.options.changes.pipe(
               map(() => {
                  return this.trigger.singleSelect.options.length;
               })
            )
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe(() => {
            this.trigger.singleSelect.setVisibility();
            this.changeDetectorRef.markForCheck();

            if (!this.value) {
               if (this.trigger.singleSelect.isIncludeEmptyOption || this.trigger.singleSelect.autoActiveFirstOption) {
                  this.trigger.singleSelect.keyManager.setActiveItem(0);
               }
            } else {
               this.setActiveItem(this.value);
            }
         });
   }

   private formatSearchText(searchText: string | null | undefined): string | null | undefined {
      return searchText ? searchText.replace(/\\/g, '') : searchText;
   }

   private setActiveItem(value: TItem | null): void {
      const index = this.trigger.singleSelect.options.toArray().findIndex((i) => {
         return i.value === value;
      });
      this.trigger.singleSelect.keyManager.setActiveItem(index);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
